import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Loading from "../../../../hoc/Loading/Loading";
import axios from "../../../../axios";
import * as actionCreators from "../../../../modules/actions/index";
import { connect } from "react-redux";
import * as url from "../../../../utils/url";
import { newDashboard, renderGenderPronoun } from "../../../../utils/constants";
import Toggle from "react-toggle";
// import DashboardChartList from './AddCharts/DashboardChartList'
import {
  Form,
  FormGroup,
  FormFeedback,
  Col,
  Label,
  Input,
  Button,
  Row,
  CustomInput,
  Popover,
  PopoverHeader,
  PopoverBody,
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Modal,
  ModalBody,
  ModalHeader,
  Table,
} from "reactstrap";
import Checkbox from "rc-checkbox";
import findIndex from "lodash/findIndex";
import filter from "lodash/filter";
import DashboardSettings from "./DashboardSettings/DashboardSettings";
import moment from "moment";
import Select from "react-select";
import { isEmpty } from "lodash";
import NoKpiPlaceholder from "../../../../assets/placeholders/no_kpi_available.svg";
import CreateDashboard from "../Reusable/CreateDashboard";

class DashboardListTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      updatedFields: [],
      title: "",
      isChartList: false,
      dashboardCharts: [],
      dashboardTools: [],
      currentDashboard: null,
      linkedItems: [],
      allDashboards: [],
      allItems: [],
      notes: [],
      attachments: [],
      linkedItemsCount: null,
      isResourceSelect: null,
      searchedTerm: "",
      isEmpty: false,
    };
  }

  componentDidMount() {
    //  getDashboards
    let { organizationId } = this.props.user.profile;
    axios
      .post(url.getDashboardList, { organizationId: organizationId._id })
      .then((response) => {
        // /dashboard/:orgId/view/:id
        let list = response.data.data;
        // console.log('all dashboards: ', list)
        this.setState({ allDashboards: list });
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        let { allDashboards } = this.state;
        if (allDashboards == 0) {
          this.setState({ isEmpty: true });
        }
      });
  }

  changeDashboardTitle = (name) => {
    let { currentDashboard } = this.state;
    let obj = {
      ...currentDashboard,
      name,
    };
    this.setState({ currentDashboard: obj });
  };

  dateChange = (startDate, endDate) => {
    let { currentDashboard } = this.state;
    let obj = {
      ...currentDashboard,
      startDate,
      endDate,
    };
    this.setState({ currentDashboard: obj });
  };

  navigate = () => {
    this.props.history.push("/home/analytics/all");
  };

  closeActionsModal = () => {
    this.setState({
      isResourceSelect: null,
    });
  };

  renderPrivacyOptions = () => {
    return this.privacyContent("enable");
    // if(chartDetails && chartDetails.createdBy  && chartDetails.createdBy._id){
    //     if(chartDetails.createdBy._id===user._id){
    //       return this.privacyContent("enable")
    //     } else if(isCopied) {
    //       return this.privacyContent("enable")
    //     } else {
    //       return this.privacyContent("disable")
    //     }
    // } else {
    //   return this.privacyContent("enable")
    // }
  };

  viewDashboard = (id) => {
    // console.log('report id: ', id)
    this.props.history.push(
      `/home/dashboard/${this.props.user.profile.organizationId._id}/view/${id}`
    );
  };
  viewDashboardReport = (id) => {
    // console.log('report id: ', id)
    this.props.history.push(
      `/home/dashboard/${this.props.user.profile.organizationId._id}/view/${id}?report=true`
    );
  };

  createDashboardModal = () => {
    this.setState({ isCreateModal: true });
  };

  renderPermissions = () => {
    let {
      privacy,
      invitedUsers,
      displayUsers,
      isUserList,
      customUser,
    } = this.state;
    if (privacy == "ENTERPRISE") {
      return (
        <span className="permissionsContainer">
          <span className="dashboard-permission-label">Permissions:</span>

          <div className="dashboardPermissionOptions">
            <span className="dbPermissionValue">View Only</span>
            <span className="ml10">
              <Toggle
                defaultChecked={this.state.permission === "EDIT"}
                icons={false}
                onChange={this.handlePermissionChange}
              />
            </span>
            <span className="dbPermissionValue ml10">View And Edit</span>
          </div>
        </span>
      );
    } else if (privacy == "CUSTOM" && isUserList) {
      return (
        <span>
          <span className="permissionsContainer">
            <Input
              name="assignedUser"
              id=""
              placeholder={"Select users to share this dashboard with"}
              className="inputBox-height"
              onChange={this.assignedUserDelay}
              value={customUser}
              autoComplete={"off"}
            />
            {displayUsers &&
            displayUsers.length > 0 &&
            typeof displayUsers !== "string" ? (
              <div className="divTableSingleTask">
                <div className="dbTableBody">
                  {displayUsers.map((user) => {
                    return (
                      <div
                        className="divTableRow"
                        onClick={() => this.onUserSelect(user)}
                        key={user._id + user.organizationId}
                      >
                        <div className="dashboardTableCell">
                          {user.firstName} {user.lastName}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : typeof displayUsers === "string" ? (
              <span className="noUsersFound">{displayUsers}</span>
            ) : null}
          </span>

          {invitedUsers.length > 0 ? (
            <Table responsive hover className="dbPrivacyTable">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Access</th>
                </tr>
              </thead>
              <tbody>
                {invitedUsers.map((e) => {
                  let fullName = e.firstName + " " + e.lastName;
                  return (
                    <tr className="dbPrivacyRow" key={e.userId}>
                      <td>{fullName}</td>

                      <td>
                        <Select
                          isClearable={false}
                          name="permission-select"
                          placeholder={"Select a permission/privacy"}
                          value={e.permissions}
                          isOpen={true}
                          options={[
                            { label: "View", value: 0 },
                            { label: "Edit", value: 1 },
                          ]}
                          onChange={(itm) => this.onUserSetPermissions(itm, e)}
                          className="basic-multi-select"
                          classNamePrefix="select"
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          ) : null}
        </span>
      );
    }
  };

  getUserName = (user) => {
    if (user.firstName && user.lastName) {
      return `${user.firstName} ${user.lastName}`;
    } else if (user.firstName && !user.lastName) {
      return `${user.firstName}`;
    } else if (!user.firstName && user.lastName) {
      return `${user.lastName}`;
    }
  };

  dashboardListView = () => {
    let { allDashboards } = this.state;
    // console.log('list view -----')
    const widths = ["25%", "20%", "15%", "20%", "20%"];
    return (
      <div className="dashboard-list-table-shadow">
        <Table hover className="mb-0">
          <thead>
            <tr className="dashboardListHeaders">
              <th style={{width:"25%"}}>Name</th>
              <th style={{width:"20%"}}>Owner</th>
              <th style={{width:"15%"}}>Access</th>
              <th style={{width:"20%"}}>Last Updated</th>
              <th style={{width:"20%"}}>Chart count</th>
            </tr>
          </thead>
        </Table>
        <div
          className="no-scr-mob dashboardTableList"
          style={{ maxHeight: "200px", overflowY: "auto", display: "block" }}
        >
          <Table responsive>
            <tbody>
              {allDashboards.map((e, i) => {
                let recent =
                  e.lastUpdate &&
                  e.lastUpdate.length > 0 &&
                  e.lastUpdate[0].date &&
                  e.lastUpdate[0].date !== null &&
                  e.lastUpdate[0].date != undefined
                    ? e.lastUpdate[0]
                    : { date: e.createdDate };
                return (
                  <tr className="dashboardListRows" key={e._id}>
                    <td style={{ width: widths[0] }}>
                      <span
                        className="dashboardListSingleLink"
                        onClick={() => this.viewDashboard(e._id)}
                      >
                        {" "}
                        {e.name}{" "}
                      </span>
                      <div
                        className="link-text"
                        onClick={() => {
                          this.viewDashboardReport(e._id);
                        }}
                      >
                        Reports
                      </div>
                    </td>

                    <td style={{ width: widths[1] }}>
                      <span className="dashboardListSingleOwner">
                        {e.createdBy.firstName} {e.createdBy.lastName}{" "}
                        <span className="user_gender_pronoun_analytics">
                          {" "}
                          {renderGenderPronoun(e.createdBy)}
                        </span>
                      </span>
                    </td>

                    <td style={{ width: widths[2] }}>
                      {/* {e.privacy} */}
                      <span className="dashboardListAccessValue">
                        {e.privacy === "PRIVATE"
                          ? "Owner Only"
                          : e.privacy == "ENTERPRISE"
                          ? "Everyone"
                          : "Shared with others"}
                      </span>
                    </td>

                    <td style={{ width: widths[3] }}>
                      <div className="lastUpdateDate">
                        {moment(recent.date).format("MMMM D, YYYY h:mm a")}
                      </div>
                      {recent.updatedBy &&
                      Object.keys(recent.updatedBy).length > 0 ? (
                        <span className="lastUpdateUser">
                          {" "}
                          {this.getUserName(recent.updatedBy)}{" "}
                        </span>
                      ) : (
                        <span className="lastUpdateUser">
                          {e.createdBy.firstName} {e.createdBy.lastName}
                        </span>
                      )}
                    </td>

                    <td style={{ width: widths[4] }}>
                      {!e.chartCount ? 0 : e.chartCount}
                    </td>

                    {/* <td>
                      <Select
                        isClearable={false}

                          name="permission-select" 
                          placeholder={"Select a permission/privacy"} 
                          value={e.permissions} 
                          isOpen={true}
                          options={[
                            {label: 'View', value:0},
                            {label: 'Edit', value:1},
                          ]} 
                          onChange={itm =>this.onUserSetPermissions(itm, e)}  
                          className="basic-multi-select"
                          classNamePrefix="select"
                          />
                </td> */}
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      </div>
    );
  };

  newDashboardUrl = (url) => {
    this.props.newDashboardUrl(url);
  };

  closeActionsModal = () => {
    this.setState((prevState) => ({
      ...newDashboard,
      isCreateModal: false,
    }));
  };

  noDashoardsViews = () => {
    let { isCreateModal } = this.state;
    // console.log('no view -----')
    return (
      <span className="dashboardTableList">
        <div
          responsive
          hover
          className="table table-hover noDashboardsTableContainer"
        >
          <div>
            <div className="noDashboardListHeaders">
              <th>Name</th>
              <th>Owner</th>
              <th>Access</th>
              <th>Last Updated</th>
              <th> Chart count </th>
            </div>
          </div>
          <div>
            <div className="noDashboardsCreated">
              {/* <div class="content-overlay"></div> */}
              <span className="dashboardAddChartImgContainer">
                <img
                  src={NoKpiPlaceholder}
                  onClick={() => this.createDashboardModal()}
                />
                <span
                  className="dashboardAddChartTxt"
                  onClick={() => this.createDashboardModal()}
                >
                  Click here to create a dashboard
                </span>
              </span>
            </div>
          </div>
        </div>

        <CreateDashboard
          isCreateModal={isCreateModal}
          closeActionsModal={this.closeActionsModal}
          newDashboardUrl={this.newDashboardUrl}
        />
      </span>
    );
  };

  loadingDashboardsView = () => {
    // console.log('nloadingo view -----')
    return (
      <span className="dashboardTableList">
        <Table responsive hover className="">
          <thead>
            <tr className="dashboardListHeaders">
              <th>Name</th>
              <th>Owner</th>
              <th>Access</th>
              <th>Last Updated</th>
              <th>Chart count</th>
            </tr>
          </thead>
          <tbody>
            <tr className="dashboardListRows">
              <td>
                <span className="dashboardListSingleLink"> Loading...</span>
              </td>

              <td>
                <span className="dashboardListSingleOwner">Loading...</span>
              </td>

              <td>
                <span className="dashboardListAccessValue">Loading...</span>
              </td>

              <td>
                <div className="lastUpdateDate"> Loading...</div>
              </td>

              <td>
                <div className="lastUpdateDate"> Loading...</div>
              </td>
            </tr>
          </tbody>
        </Table>
      </span>
    );
  };

  renderView = () => {
    let { allDashboards, isEmpty } = this.state;
    if (allDashboards.length > 0) {
      return this.dashboardListView();
    } else if (allDashboards.length == 0) {
      if (isEmpty) {
        return this.noDashoardsViews();
      } else {
        return this.loadingDashboardsView();
      }
    }
  };

  render() {
    return this.renderView();
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onKpiMasterListFetched: (data) =>
      dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: (data) =>
      dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: (data) =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Loading(DashboardListTable, axios)));
